export default {
  emptyText: 'No shop layout selected',
};
